import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setStatus } from "../../../../redux/slices/item/itemSlice";

function ToggleDetails() {
  const dispatch = useDispatch();
  const Status = useSelector((state) => state.item.ToggleStatus);
  const ItemDetails = useSelector((state) => state.item.ItemDetails);

  return (
    <div className="flex items-center justify-center w-full mt-8 mb-6">
      <label htmlFor="toggleB" className="flex items-center ">
        <div className="relative">
          <input id="toggleB" className="sr-only" />
          {ItemDetails.product_type === "assembly" ? (
            <div className="block bg-cyan-100 w-128 h-10 rounded-full">
              <div className="flex flex-row justify-around pt-3">
                <p
                  onClick={() => dispatch(setStatus("General"))}
                  className="pl-4 text-xs font-semibold text-gray-900 font-Montserrat cursor-pointer"
                >
                  General
                </p>
                <p
                  onClick={() => dispatch(setStatus("Bom"))}
                  className="text-xs font-semibold text-gray-900 font-Montserrat cursor-pointer"
                >
                  BOM
                </p>
                <p
                  onClick={() => dispatch(setStatus("Details"))}
                  className="pl-4 text-xs font-semibold text-gray-900 font-Montserrat cursor-pointer"
                >
                  Details
                </p>
                <p
                  onClick={() => dispatch(setStatus("Transactions"))}
                  className="text-xs font-semibold text-gray-900 font-Montserrat cursor-pointer"
                >
                  Transactions
                </p>
              </div>
            </div>
          ) : (
            <div className="block bg-cyan-100 w-96 h-10 rounded-full">
              <div className="flex flex-row justify-evenly pt-3">
                <p
                  onClick={() => dispatch(setStatus("General"))}
                  className="pl-4 text-xs font-semibold text-gray-900 font-Montserrat cursor-pointer"
                >
                  General
                </p>
                <p
                  onClick={() => dispatch(setStatus("Details"))}
                  className="pl-4 text-xs font-semibold text-gray-900 font-Montserrat cursor-pointer"
                >
                  Details
                </p>
                <p
                  onClick={() => dispatch(setStatus("Transactions"))}
                  className="text-xs font-semibold text-gray-900 font-Montserrat cursor-pointer"
                >
                  Transactions
                </p>
              </div>
            </div>
          )}
          {ItemDetails.product_type == "assembly" ? (
            <>
              {" "}
              {Status === "General" ? (
                <div className="absolute left-4 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                  General
                </div>
              ) : null}
              {Status === "Bom" ? (
                <div className="absolute left-36 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                  BOM
                </div>
              ) : null}
              {Status === "Details" ? (
                <div className="absolute left-64 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                  Details
                </div>
              ) : null}
              {Status === "Transactions" ? (
                <div className="absolute left-96 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                  Transactions
                </div>
              ) : null}
            </>
          ) : (
            <>
              {" "}
              {Status === "General" ? (
                <div className="absolute left-8 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                  General
                </div>
              ) : null}
              {Status === "Details" ? (
                <div className="absolute left-36 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                  Details
                </div>
              ) : null}
              {Status === "Transactions" ? (
                <div className="absolute left-64 top-1 bg-white w-24 h-8 rounded-full transition shadow-md text-xs font-semibold text-blue-100 font-Montserrat text-center pt-2">
                  Transactions
                </div>
              ) : null}
            </>
          )}
        </div>
      </label>
    </div>
  );
}

export default ToggleDetails;
